import React, { Fragment } from 'react';
import QRCode from "react-qr-code";

import { LockerOrder } from '../../../../store/modules/order/types';

import {
  Root,
  ContainerAddress,
  AddressTitle,
  AddressContent
} from './styles';

interface InfoLockerProps {
  locker: LockerOrder;
}

const InfoLocker: React.FC<InfoLockerProps> = ({locker} : InfoLockerProps) => {
  return (
    <Root>
        <ContainerAddress>
          <AddressTitle>Endereço do Locker</AddressTitle>
          <AddressContent>
            <div>
              {locker.address.address}
            </div>
            <div>
              {locker.address.neighborhood}
            </div>
            <div>
                {` ${locker.address.city} - ${locker.address.state}`}
            </div>
            {locker.store && (
              <div>
                {`Nome da loja: ${locker.store.store_name}`}
              </div>
            )}
          </AddressContent>
        </ContainerAddress>

        <section>
          <AddressTitle>Portas do locker para retirada:</AddressTitle>
          <div>
            {locker.doors.map((door,idx) => 
              <Fragment key={door.door_id}>
                {`Porta ${door.door_id}${locker.doors.length > 1 && (idx + 1) < locker.doors.length ? ', ' : ''}`}
              </Fragment>
              )}
          </div>
        </section>
              
        <QRCode value={locker.token} />
        <div>
        {locker.token}
        </div>
    </Root>
  );
};

export default InfoLocker;
